import { useCallback, useMemo } from "react";
import { useLivePreview } from "@payloadcms/live-preview-react";
import { getPayloadCmsUrl } from "src/api/payload/client";
import { mapPromotion } from "src/utils/mapPromotion";
import { promotionsLivePreviewRequestHandler } from "src/utils/promotionsLivePreviewHandler";

/**
 * Fusionne les données live d'une carte promotion dans la liste hub.
 *
 * @param {import('src/utils/mapPromotion').PromotionCard[]} promotions
 * @param {boolean} enabled - true quand REACT_APP_PROMOTIONS_SOURCE=payload
 * @param {string} [locale] - `en` | `fr`
 */
export function usePromotionsLivePreview(promotions, enabled, locale) {
  const initialDoc = useMemo(() => ({}), []);
  const requestHandler = useCallback(promotionsLivePreviewRequestHandler, []);

  const { data: liveDoc, isLoading } = useLivePreview({
    initialData: initialDoc,
    serverURL: getPayloadCmsUrl(),
    depth: 0,
    requestHandler,
  });

  const mergedPromotions = useMemo(() => {
    if (!enabled || !liveDoc?.key) return promotions;

    const liveCard = mapPromotion(liveDoc, locale);

    const index = promotions.findIndex((p) => p.key === liveCard.key);
    if (index >= 0) {
      const next = [...promotions];
      next[index] = { ...next[index], ...liveCard };
      return next;
    }

    return [...promotions, liveCard];
  }, [promotions, liveDoc, enabled, locale]);

  return {
    promotions: mergedPromotions,
    isLivePreview: Boolean(liveDoc?.key),
    livePreviewKey: liveDoc?.key,
    isLoadingLivePreview: isLoading,
  };
}
